import React from "react";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";

const SlopeSocialPage = () => {
  return (
    <div className="min-h-screen page-enter">
      {/* Section 1: Key Trip Details with Hero Image */}
      <div className="relative min-h-screen md:min-h-screen flex flex-col justify-center items-center text-center px-6 pt-24 mobile-hero-height">
        {/* Background Images - Desktop and Mobile Versions */}
        <div className="absolute inset-0 z-0 scale-in" style={{top: '80px'}}>
          {/* Desktop Version */}
          <img 
            src="https://customer-assets.emergentagent.com/job_codebase-navigator-1/artifacts/owmaeba1_Slope%20Social%20I%20Homepage.png"
            alt="Slope Social I - Bear Creek Mountain Resort"
            className="slope-hero-desktop w-full h-full object-cover object-center"
            style={{objectPosition: 'center 40%'}}
          />
          {/* Mobile Version - Cropped to fit text section */}
          <img 
            src="https://customer-assets.emergentagent.com/job_codebase-navigator-1/artifacts/owmaeba1_Slope%20Social%20I%20Homepage.png"
            alt="Slope Social I - Bear Creek Mountain Resort Mobile"
            className="slope-hero-mobile w-full object-cover object-center"
            style={{
              objectPosition: '50% -50%',
              height: '60vh',
              objectFit: 'cover'
            }}
          />
        </div>

        {/* Navigation */}
        <div className="absolute top-0 left-0 right-0 z-20 slide-in-top">
          <Navigation />
        </div>

        {/* Hero Content - Text removed to show image content */}
      </div>

      {/* Section 2: Package Details with Integrated Photos */}
      <section className="pt-6 pb-20 bg-white relative overflow-hidden">
        <div className="max-w-8xl mx-auto px-6">
          {/* Floating Accent Images */}
          <div className="absolute top-24 left-8 z-10 hidden lg:block opacity-20 stagger-3">
            <div className="w-32 h-40 rounded-xl overflow-hidden shadow-xl transform rotate-12 gallery-item">
              <img src="https://customer-assets.emergentagent.com/job_codebase-navigator-1/artifacts/og8sukzm_BC%201.jpg" className="w-full h-full object-cover" alt="accent" />
            </div>
          </div>
          
          <div className="absolute top-32 right-8 z-10 hidden lg:block opacity-20 stagger-4">
            <div className="w-28 h-36 rounded-xl overflow-hidden shadow-xl transform -rotate-12 gallery-item">
              <img src="https://customer-assets.emergentagent.com/job_codebase-navigator-1/artifacts/jglqfehn_BC%203.jpg" className="w-full h-full object-cover" alt="accent" />
            </div>
          </div>

          {/* Main Content */}
          <div className="relative z-20">
            <div className="text-center mb-12">
              <div className="inline-block p-1 rounded-full bg-gradient-to-r from-blue-400 to-purple-500 mb-8">
                <div className="bg-white rounded-full px-6 py-2">
                  <span className="text-blue-600 text-sm font-medium">Package Details</span>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-slate-50 to-white rounded-3xl p-8 shadow-xl border border-slate-100 max-w-4xl mx-auto">
              <div className="space-y-6">
                <p className="text-lg text-slate-700 leading-relaxed">
                  Here at takeatrip nyc, we want to make your travel experience as hassle-free as possible so that you can maximize your enjoyment. To deliver on that, we've partnered with Bear Creek Mountain Resort to put together a robust, one-price package for all your needs. Check out everything that's included below!
                </p>
                
                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <h3 className="text-xl font-bold text-slate-800 mb-4">All packages will include:</h3>
                  <div className="space-y-3 text-slate-700">
                    <div className="flex items-start space-x-3">
                      <span className="text-blue-500">🔹</span>
                      <span>Lift ticket (1 day)</span>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="text-blue-500">🔹</span>
                      <span>Ski or snowboard equipment rental package (1 day)</span>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="text-blue-500">🔹</span>
                      <span>Group beginner lesson</span>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="text-blue-500">🔹</span>
                      <span>Group snowtubing</span>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="text-blue-500">🔹</span>
                      <span>3 days, 2 nights stay in luxury resort (double Queen bed room)</span>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="text-blue-500">🔹</span>
                      <span>Access to resort amenities</span>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="text-blue-500">🔹</span>
                      <span>Transportation from NYC via chartered bus</span>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="text-blue-500">🔹</span>
                      <span>3 group meals (one breakfast & two dinners)</span>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="text-blue-500">🔹</span>
                      <span>Aprés-ski</span>
                    </div>
                  </div>
                </div>
                
                <div className="bg-blue-50 rounded-2xl p-6 border-l-4 border-blue-400">
                  <p className="text-slate-700 leading-relaxed mb-4">
                    Please note that each package includes one individual spot in a shared unit. If you have a preferred traveler that you would like to room with, please denote that in the roommate section on the checkout page. While we will do our best to accommodate these preferences, placements are subject to space and cannot be guaranteed.
                  </p>
                  <p className="text-slate-700 leading-relaxed mb-4">
                    At this time, packages cannot be customized to accommodate specific configurations (e.g., requesting to remove lodging, deciding not to go snow tubing, etc.).
                  </p>
                  <p className="text-slate-700 leading-relaxed">
                    At checkout, you may see an additional charge for Stripe processing fees.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Gallery Section 1: Main Triple Layout - After Package Details */}
        <div className="max-w-8xl mx-auto px-6 mt-16">
          <div className="grid grid-cols-12 gap-8 h-[500px]">
            {/* Left side - Stacked */}
            <div className="col-span-12 md:col-span-4 flex flex-col gap-6">
              <div className="h-72 group cursor-pointer rounded-[2.5rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-2 hover:rotate-2 relative">
                <img src="https://customer-assets.emergentagent.com/job_codebase-navigator-1/artifacts/mt5qyr9w_BC%204.jpg" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" style={{objectPosition: 'center 45%'}} alt="Resort Luxury" />
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
              <div className="h-56 group cursor-pointer rounded-[2.5rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-4 hover:-rotate-1">
                <img src="https://customer-assets.emergentagent.com/job_codebase-navigator-1/artifacts/f6lkb979_BC%205.jpg" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" style={{objectPosition: 'center 80%'}} alt="Resort Activities" />
              </div>
            </div>
            
            {/* Center - Extra large hero */}
            <div className="col-span-12 md:col-span-4 group cursor-pointer rounded-[2.5rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-1 hover:-rotate-1 relative">
              <img src="https://customer-assets.emergentagent.com/job_codebase-navigator-1/artifacts/jsrf5iiv_BC%208%20%281%29.jpg" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" style={{objectPosition: 'center 40%'}} alt="Resort Amenities" />
              <div className="absolute inset-0 bg-gradient-to-t from-purple-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
            
            {/* Right side - Single tall */}
            <div className="col-span-12 md:col-span-4 group cursor-pointer rounded-[2.5rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-3 hover:rotate-2">
              <img src="https://customer-assets.emergentagent.com/job_codebase-navigator-1/artifacts/rt44it39_BC%206%20%281%29.jpg" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" style={{objectPosition: 'center 45%'}} alt="Ski Slopes" />
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Checkout - Between Image Blocks */}
      <section className="py-20 px-6 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-block p-1 rounded-full bg-gradient-to-r from-emerald-400 to-cyan-500 mb-8">
            <div className="bg-white rounded-full px-6 py-2">
              <span className="text-emerald-600 text-sm font-medium">Secure Your Enjoyment</span>
            </div>
          </div>
          
          <div className="space-y-8">
            <div className="mb-8">
              <Button 
                size="lg"
                className="w-full max-w-md mx-auto py-6 text-xl font-semibold rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl text-white"
                style={{
                  background: 'linear-gradient(to right, #1d476a, rgb(51 65 85))',
                  border: 'none'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'linear-gradient(to right, #163d56, rgb(45 55 72))';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'linear-gradient(to right, #1d476a, rgb(51 65 85))';
                }}
                onClick={() => {
                  window.open('https://buy.stripe.com/5kQ9AL7hW9Cp5PJ0EB0sU00', '_blank');
                }}
              >
                Checkout - $699
              </Button>
            </div>
            
            <div className="mt-8">
              <Link to="/faq">
                <Button 
                  size="lg"
                  variant="outline"
                  className="w-full max-w-md mx-auto py-4 text-lg rounded-full transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
                  style={{
                    borderColor: '#1d476a',
                    color: '#1d476a'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(29, 71, 106, 0.05)';
                    e.target.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.transform = 'scale(1)';
                  }}
                >
                  FAQs
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section 2: After FAQ - BC9 & BC10 Only */}
      <section className="py-16 bg-white relative">
        <div className="max-w-8xl mx-auto px-6">
          <div className="grid grid-cols-12 gap-6 h-[400px]">
            {/* BC9 - Single image taking full width */}
            <div className="col-span-12 h-full group cursor-pointer rounded-[2rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-4 hover:-rotate-1">
              <img src="https://customer-assets.emergentagent.com/job_codebase-navigator-1/artifacts/swrmd06s_BC%209.jpg" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" style={{objectPosition: 'center 45%'}} alt="Mountain Views" />
            </div>
          </div>

          <div className="grid grid-cols-12 gap-6 h-[350px] mt-8">
            {/* BC10 - Full width */}
            <div className="col-span-12 h-full group cursor-pointer rounded-[2rem] overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-700 transform hover:-translate-y-1 hover:rotate-1">
              <img src="https://customer-assets.emergentagent.com/job_codebase-navigator-1/artifacts/a2iimjst_BC%2010.jpg" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" style={{objectPosition: 'center 35%'}} alt="Night Skiing" />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SlopeSocialPage;